module.exports = __webpack_public_path__ + "img/icon-protrain-4.786fc559.png";